import { defineStore } from "pinia";
import { pushSubscriptionService } from "@/services/pushSubscriptionService";
import { useToast } from "vue-toastification";
import "vue-toastification/dist/index.css";

const toast = useToast();

export const usePushStore = defineStore("push", {
  state: () => ({
    isPushEnabled: "serviceWorker" in navigator && "PushManager" in window,
    isSubscribed: false,
    isLoading: false,
    devices: [],
  }),
  actions: {
    async checkSubscriptionStatus() {
      if (!this.isPushEnabled) return;
      this.isLoading = true;
      try {
        const subscription =
          await pushSubscriptionService.getCurrentSubscription();
        this.isSubscribed = !!subscription;
        this.devices = await pushSubscriptionService.listMyDevices();
      } catch (e) {
        console.error(e);
      } finally {
        this.isLoading = false;
      }
    },

    async toggleSubscription() {
      this.isLoading = true;
      try {
        if (this.isSubscribed) {
          await pushSubscriptionService.unsubscribeUser();
          this.isSubscribed = false;
          toast.warning("Đã hủy nhận thông báo trên thiết bị hiện tại!");
        } else {
          await pushSubscriptionService.subscribeUser();
          this.isSubscribed = true;
          toast.success("Đăng ký nhận thông báo trên thiết bị hiện tại!");
        }
        this.devices = await pushSubscriptionService.listMyDevices();
      } catch (error) {
        console.error("Lỗi khi bật/tắt thông báo:", error);
        toast.error("Đã có lỗi xảy ra. Vui lòng thử lại.");
      } finally {
        this.isLoading = false;
      }
    },

    async fetchDevices() {
      try {
        this.devices = await pushSubscriptionService.listMyDevices();
      } catch (e) {
        console.error(e);
      }
    },

    async removeDevice(endpoint) {
      try {
        await pushSubscriptionService.removeDeviceByEndpoint(endpoint);
        toast.info("Đã hủy đăng ký thiết bị.");
        await this.fetchDevices();
        const sub = await pushSubscriptionService.getCurrentSubscription();
        this.isSubscribed = !!sub;
      } catch (e) {
        console.error(e);
        toast.error("Không thể hủy thiết bị. Thử lại sau.");
      }
    },

    async subscribeCurrentDevice() {
      try {
        await pushSubscriptionService.subscribeUser();
        toast.success("Thiết bị hiện tại đã được đăng ký nhận thông báo!");
        await this.fetchDevices();
        this.isSubscribed = true;
      } catch (e) {
        console.error(e);
        toast.error("Không thể đăng ký thiết bị hiện tại.");
      }
    },
  },
});
